import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateTeamMessage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image: null,
    existingImage: ''
  });

  // Fetch message by ID
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}team-message/${id}`)
      .then((res) => {
        setFormData({
          name: res.data.name,
          description: res.data.description,
          image: null,
          existingImage: res.data.image ? `${process.env.REACT_APP_BACKEND_URL}uploads/messages/${res.data.image}` : ''
        });
      })
      .catch((err) => {
        console.error('Error fetching team message:', err);
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const updatedData = new FormData();
  //   updatedData.append("name", formData.name);
  //   updatedData.append("description", formData.description);
  //   if (formData.image instanceof File) {
  //     updatedData.append("image", formData.image);
  //   }

  //   axios
  //     .put(`${process.env.REACT_APP_BACKEND_URL}team-message/${id}`, updatedData)
  //     .then(() => {
  //       alert("Team message updated successfully!");
  //       navigate("/team-message/list");
  //     })
  //     .catch((err) => {
  //       console.error("Update failed:", err);
  //       alert("Failed to update team message");
  //     });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedData = new FormData();
    updatedData.append('name', formData.name);
    updatedData.append('description', formData.description);

    if (formData.image instanceof File) {
      updatedData.append('image', formData.image);
    }

    axios
      .patch(`${process.env.REACT_APP_BACKEND_URL}message/${id}`, updatedData) // ✅ PATCH
      .then(() => {
        alert('Team message updated successfully!');
        navigate('/team-message/list');
      })
      .catch((err) => {
        console.error('Update failed:', err);
        alert('Failed to update team message');
      });
  };

  return (
    <div className="max-w-xl mx-auto mt-10 p-6 bg-white shadow-md rounded-md">
      <h2 className="text-2xl font-bold mb-6">Update Team Message</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-4">
          <label htmlFor="name" className="block mb-1 font-semibold">
            Name
          </label>
          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="description" className="block mb-1 font-semibold">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
            rows={4}
            required
          />
        </div>

        <div className="mb-4">
          <label htmlFor="image" className="block mb-1 font-semibold">
            Upload Image
          </label>
          <input id="image" type="file" name="image" accept="image/*" onChange={handleChange} className="w-full" />
        </div>

        {formData.image ? (
          <img src={URL.createObjectURL(formData.image)} alt="preview" className="mb-4 w-32 rounded" />
        ) : formData.existingImage ? (
          <img src={formData.existingImage} alt="existing" className="mb-4 w-32 rounded" />
        ) : null}

        <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition">
          Update Team Message
        </button>
      </form>
    </div>
  );
};

export default UpdateTeamMessage;
